import React, { useState, useEffect } from 'react';
import { Table, Button, Tag, Popconfirm, Space, Input, Select, Typography, message } from 'antd';
import { DeleteOutlined, SearchOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import api from '../api';

const { Title, Text } = Typography;

const typeMap = {
  text: { label: '文本', color: 'default' },
  image: { label: '图片', color: 'blue' },
  voice: { label: '语音', color: 'green' },
  video: { label: '视频', color: 'orange' },
  file: { label: '文件', color: 'purple' },
  location: { label: '位置', color: 'cyan' },
};

function MessageManagePage() {
  const [messages, setMessages] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [loading, setLoading] = useState(false);

  const loadMessages = async (p = 1) => {
    setLoading(true);
    try {
      const params = { page: p, limit: 30 };
      if (keyword) params.keyword = keyword;
      const { list, total: t } = await api.get('/admin/messages', { params });
      setMessages(list);
      setTotal(t);
      setPage(p);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadMessages(); }, []);

  const handleSearch = () => loadMessages(1);

  const handleDelete = async (id) => {
    await api.delete(`/admin/messages/${id}`);
    message.success('消息已删除');
    loadMessages(page);
  };

  const columns = [
    { title: 'ID', data: 80, data: 'id' },
    {
      title: '发送者', width: 120,
      render: (_, r) => <Space><span style={{ color: '#07C160' }}>{r.from_name}</span></Space>,
    },
    {
      title: '接收者', width: 120,
      render: (_, r) => <Space><span>{r.to_name}</span></Space>,
    },
    { title: '内容', dataIndex: 'content', ellipsis: true, width: 300 },
    {
      title: '类型', width: 80,
      render: (_, r) => <Tag color={typeMap[r.type]?.color}>{typeMap[r.type]?.label || r.type}</Tag>,
    },
    {
      title: '状态', width: 80,
      render: (_, r) => r.status === 1 ? <Tag color="green">正常</Tag> : <Tag color="red">已撤回</Tag>,
    },
    { title: '发送时间', dataIndex: 'created_at', width: 160, render: (v) => v ? new Date(v).toLocaleString() : '-' },
    {
      title: '操作', width: 100,
      render: (_, r) => (
        <Popconfirm title="确定删除该消息?" onConfirm={() => handleDelete(r.id)} icon={<ExclamationCircleOutlined style={{ color: 'red' }} />}>
          <Button size="small" danger icon={<DeleteOutlined />}>删除</Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={4}>消息管理</Title>
        <Space>
          <Input placeholder="搜索消息内容" value={keyword} onChange={(e) => setKeyword(e.target.value)} onPressEnter={handleSearch} style={{ width: 200 }} prefix={<SearchOutlined />} />
          <Button type="primary" onClick={handleSearch}>搜索</Button>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={messages}
        rowKey="id"
        loading={loading}
        size="small"
        pagination={{ current: page, total, pageSize: 30, onChange: loadMessages, showSizeChanger: false }}
      />
    </>
  );
}

export default MessageManagePage;
